import { render, staticRenderFns } from "./modifyContact.vue?vue&type=template&id=0c44f106&scoped=true&"
import script from "./modifyContact.vue?vue&type=script&lang=js&"
export * from "./modifyContact.vue?vue&type=script&lang=js&"
import style0 from "./modifyContact.vue?vue&type=style&index=0&id=0c44f106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44f106",
  null
  
)

export default component.exports